export default {
  stockItemFiles: [],
  stockItemFile: undefined,
};
